import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AdminTenantService } from '@app/services/admin-tenant/admin-tenant.service';
import { AdminThemeService } from '@app/services/admin-theme/admin-theme.service';
import { AdminUserService } from '@app/services/admin-user/admin-user.service';
import { environment } from '@environments/_current/environment';
import { EnterpriseTenant, TenantTheme, User } from '@skyfit/core-data-library';
import { map, Observable, of, tap } from 'rxjs';
export interface BootstrapData {
  user: User;
  tenant: EnterpriseTenant;
  theme: TenantTheme;
}

@Injectable({
  providedIn: 'root',
})
export class AdminBootstrapService {
  private readonly http = inject(HttpClient);
  private readonly adminUserService = inject(AdminUserService);
  private readonly adminTenantService = inject(AdminTenantService);
  private readonly adminThemeService = inject(AdminThemeService);

  getBootstrapData(): Observable<BootstrapData> {
    const path = `${environment.aaptivServiceUrl}/api/v1/user/adminUI`;

    return this.http.get<BootstrapData>(path);
  }

  private applyBootstrapData(data: BootstrapData): void {
    this.adminUserService.setUser(data?.user);
    if (!this.adminTenantService.getDefaultTenantId()) {
      this.adminTenantService.setDefaultTenantId(data?.tenant?.id);
    }
    this.adminTenantService.setTenantIdInStorage(data?.tenant);
    this.adminThemeService.setTheme(data?.theme);
  }

  initializeApp(options?: { forceRefresh?: boolean }): Observable<BootstrapData> {
    const tenant = this.adminTenantService.getTenant();
    if (!options?.forceRefresh && tenant?.id) {
      return of({
        user: this.adminUserService.getUser(),
        tenant,
        theme: this.adminThemeService.getCurrentTheme(),
      } as BootstrapData);
    }

    return this.getBootstrapData().pipe(tap((data) => this.applyBootstrapData(data)));
  }

  ensureTenantLoaded(): Observable<EnterpriseTenant | undefined> {
    return this.initializeApp().pipe(map((data) => data?.tenant));
  }
}
